import { Component, Input, ViewEncapsulation } from '@angular/core';

export enum Icon {
  ArrowRight = 'arrow-right',
  Walking = 'walking',
  Plus = 'plus',
  Map = 'map',
  Close = 'close',
  ExternalLink = 'external-link',
  Mail = 'mail',
  Phone = 'phone',
  List = 'list',
}

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SvgIconComponent {
  iconEnum = Icon;
  @Input() icon: string;
  @Input() color: string = 'black';

  constructor() {}
}
